import { render } from "./EmbedCode.vue?vue&type=template&id=a0056fb6"
import script from "./EmbedCode.vue?vue&type=script&lang=js"
export * from "./EmbedCode.vue?vue&type=script&lang=js"

import "./EmbedCode.vue?vue&type=style&index=0&id=a0056fb6&lang=scss"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__